import { BUY_SIDE, SELL_SIDE } from 'bundles/backoffice/vouchers/helpers/transaction_side_details';

// TODO: Should really be using i18n instead
export function getAreaUnitsLabel(value) {
  switch (value) {
  case 'sf':
    return 'SF';
  case 'acres':
    return 'Acres';
  }
}

export function getLeaseTermUnitsLabel(value) {
  switch (value) {
  case 'months':
    return 'Months';
  case 'years':
    return 'Years';
  }
}

export function getPropertySectionLabel(deal) {
  let label = 'Property';

  if (deal.dealType === 'lease' || deal.dealType === 'tenant_rep') {
    label += ' & Space';
  }

  return label;
}

export function getLocationLabel(object, fields) {
  const parts = [];

  if (object.city && fields.city) {
    parts.push(fields.city.label);
  }

  if (object.state && fields.state) {
    parts.push(fields.state.label);
  }

  if (object.zip && fields.zip) {
    parts.push(fields.zip.label);
  }

  return parts.join(' / ');
}

export function getTransactionSideOptionLabels(dealType) {
  switch (dealType) {
  case 'lease':
  case 'tenant_rep':
    return [[BUY_SIDE, 'Tenant Side'], [SELL_SIDE, 'Owner Side']];
  default:
    return [[BUY_SIDE, 'Buy Side'], [SELL_SIDE, 'Sell Side']];
  }
}
